import { jsxs as t, jsx as o } from "react/jsx-runtime";
const n = ({ className: e }) => /* @__PURE__ */ t(
  "svg",
  {
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: e,
    children: [
      /* @__PURE__ */ o(
        "path",
        {
          d: "M30 27.1111L33.0664 29.7541C34.3554 30.8652 35 31.4207 35 32.1111C35 32.8014 34.3555 33.357 33.0664 34.4681L30 37.1111",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M23.3359 27.1111L20.2696 29.7541C18.9805 30.8652 18.3359 31.4207 18.3359 32.1111C18.3359 32.8014 18.9805 33.357 20.2696 34.4681L23.3359 37.1111",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M33.3359 22.1164L33.3359 13.4776C33.3359 10.6547 33.3359 9.24323 32.8893 8.11593C32.1714 6.30366 30.653 4.87415 28.728 4.19821C27.5306 3.77775 26.0314 3.77775 23.0329 3.77775C17.7856 3.77775 15.162 3.77775 13.0665 4.51355C9.69783 5.69646 7.04063 8.19809 5.78416 11.3696C5.0026 13.3423 5.0026 15.8124 5.0026 20.7524L5.0026 24.9961C5.0026 30.1132 5.0026 32.6718 6.41543 34.4486C6.82023 34.9577 7.3003 35.4097 7.84105 35.7908C9.36103 36.862 11.4196 37.0705 15.0026 37.1111",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ o(
        "path",
        {
          d: "M5.0013 20.4445C5.0013 17.3762 7.48861 14.8889 10.5569 14.8889C11.6665 14.8889 12.9747 15.0833 14.0536 14.7943C15.0122 14.5374 15.7609 13.7887 16.0178 12.8301C16.3068 11.7512 16.1124 10.443 16.1124 9.33335C16.1124 6.2651 18.5997 3.77779 21.668 3.77779",
          stroke: "#A8A29E",
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
);
export {
  n as CodeFileIcon
};
